<template>
  <div class="report-company">
    <el-tabs v-model="reportTabName" type="card">
      <el-tab-pane label="Transaction" name="transaction">
        <Transaction :company="companyUID" client="1"/>
      </el-tab-pane>
      <el-tab-pane label="Project" name="project">
        <Project :company="companyUID" client="1"/>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import Transaction from '@/views/report/components/company-transaction-report'
import Project from '@/views/report/components/project-report'
export default {
  props:{
    companyUID: String
  },
  components: {
    Transaction,
    Project
  },
  computed: {
    reportRole() {
      return this.roleAuth([this.role.spadmin, this.role.admin]);
    },
  },
  data() {
    return {
      reportTabName: "transaction",
    };
  },
}
</script>

<style lang="scss">
.report-company{
  background-color: white;
  .el-tabs{
    padding-top: 16px;
  }
}
</style>